export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/boy_icon.2583faf5.svg","height":19,"width":15,"blurWidth":0,"blurHeight":0};